import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "text-sm"
};
const _hoisted_2 = {
  class: "flex border-b border-slate-200 mb-2"
};
const _hoisted_3 = {
  class: "h-48 overflow-y-auto space-y-0.5"
};
const _hoisted_4 = {
  key: 0,
  class: "py-3 text-center text-xs text-slate-400"
};
const _hoisted_5 = {
  class: "w-6 h-6 rounded-full bg-primary-400 flex items-center justify-center text-[10px] text-white flex-shrink-0"
};
const _hoisted_6 = {
  class: "text-xs text-slate-700 truncate flex-1"
};
const _hoisted_7 = {
  class: "text-[10px] text-slate-400 flex-shrink-0"
};
const _hoisted_8 = {
  key: 0,
  class: "py-3 text-center text-xs text-slate-400"
};
const _hoisted_9 = {
  class: "w-6 h-6 rounded-full bg-slate-400 flex items-center justify-center text-[10px] text-white flex-shrink-0"
};
const _hoisted_10 = {
  class: "text-xs text-slate-700 truncate"
};
import { ref, computed } from 'vue';
export default {
  __name: 'ReadReceiptPopover',
  props: {
    message: {
      type: Object,
      required: true
    },
    members: {
      type: Array,
      default: () => []
    },
    currentUserId: {
      type: [String, Number],
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const visible = ref(false);
    const activeTab = ref('read');
    const readMembers = computed(() => {
      return (props.message.readBy || []).map(r => {
        const member = props.members.find(m => String(m.id) === String(r.userId));
        return {
          ...r,
          name: member?.name || r.userName || ''
        };
      });
    });
    const unreadMembers = computed(() => {
      const readUserIds = new Set((props.message.readBy || []).map(r => String(r.userId)));
      return props.members.filter(m => String(m.id) !== String(props.currentUserId) && !readUserIds.has(String(m.id)));
    });
    const readCount = computed(() => readMembers.value.length);
    const unreadCount = computed(() => unreadMembers.value.length);
    function formatReadTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      if (isNaN(date.getTime())) return '';
      const now = new Date();
      const time = date.toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      if (date.toDateString() === now.toDateString()) return time;
      return `${date.toLocaleDateString('zh-CN', {
        month: '2-digit',
        day: '2-digit'
      })} ${time}`;
    }
    return (_ctx, _cache) => {
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createBlock(_component_el_popover, {
        visible: visible.value,
        placement: "top",
        width: 240,
        "show-arrow": true,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => visible.value = $event)
      }, {
        reference: _withCtx(() => [_createElementVNode("span", {
          class: _normalizeClass(["text-[10px] cursor-pointer select-none", readCount.value > 0 ? 'text-primary-500 hover:text-primary-600' : 'text-slate-400']),
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => visible.value = !visible.value, ["stop"]))
        }, _toDisplayString(readCount.value > 0 ? `${readCount.value}人已读` : '未读'), 3)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
          class: _normalizeClass(["flex-1 pb-2 text-xs font-medium text-center transition-colors cursor-pointer", activeTab.value === 'read' ? 'text-primary-500 border-b-2 border-primary-500' : 'text-slate-400 hover:text-slate-600']),
          onClick: _cache[1] || (_cache[1] = $event => activeTab.value = 'read')
        }, " 已读 (" + _toDisplayString(readCount.value) + ") ", 3), _createElementVNode("button", {
          class: _normalizeClass(["flex-1 pb-2 text-xs font-medium text-center transition-colors cursor-pointer", activeTab.value === 'unread' ? 'text-primary-500 border-b-2 border-primary-500' : 'text-slate-400 hover:text-slate-600']),
          onClick: _cache[2] || (_cache[2] = $event => activeTab.value = 'unread')
        }, " 未读 (" + _toDisplayString(unreadCount.value) + ") ", 3)]), _createElementVNode("div", _hoisted_3, [activeTab.value === 'read' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [readMembers.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 暂无人已读 ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(readMembers.value, member => {
          return _openBlock(), _createElementBlock("div", {
            key: member.userId,
            class: "flex items-center gap-2 py-1 px-1 rounded hover:bg-slate-50"
          }, [_createElementVNode("div", _hoisted_5, _toDisplayString((member.name || member.userName || '').slice(-1)), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(member.name || member.userName), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(formatReadTime(member.readTime)), 1)]);
        }), 128))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [unreadMembers.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 全部已读 ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unreadMembers.value, member => {
          return _openBlock(), _createElementBlock("div", {
            key: member.id,
            class: "flex items-center gap-2 py-1 px-1 rounded hover:bg-slate-50"
          }, [_createElementVNode("div", _hoisted_9, _toDisplayString((member.name || '').slice(-1)), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(member.name), 1)]);
        }), 128))], 64))])])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};